import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 14C26.4183 14 30 17.5817 30 22C30 26.4183 26.4183 30 22 30C17.5818 30 14 26.4183 14 22C14 17.5817 17.5818 14 22 14ZM22 16C18.6863 16 16 18.6863 16 22C16 25.3137 18.6863 28 22 28C25.3137 28 28 25.3137 28 22C28 18.6863 25.3137 16 22 16ZM11.6129 2.2097L11.7072 2.29289L19.7072 10.2929C20.3098 10.8955 19.9277 11.9072 19.1137 11.994L19 12H18V13H16V11C16 10.6055 16.2284 10.2644 16.5602 10.1017L16.6491 10.064L11 4.415L5.35001 10.064L5.43985 10.1017C5.73847 10.2481 5.95333 10.5391 5.99332 10.8834L6.00003 11V17H12V19H5.00003C4.48719 19 4.0645 18.6139 4.00674 18.1166L4.00003 18V12H3.00003C2.14786 12 1.70263 11.0145 2.21683 10.3775L2.29288 10.2929L10.2929 2.29289C10.6534 1.93241 11.2207 1.90468 11.6129 2.2097Z"
        fill="#0090FF"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 17V18H24C24.5523 18 25 18.4477 25 19C25 19.5128 24.6139 19.9355 24.1166 19.9933L24 20H21.5C21.2239 20 21 20.2239 21 20.5C21 20.7455 21.1769 20.9496 21.4102 20.9919L21.5 21H22.5C23.8807 21 25 22.1193 25 23.5C25 24.7093 24.1414 25.7181 23.0005 25.9499L23 27H21V26H20C19.4477 26 19 25.5523 19 25C19 24.4872 19.3861 24.0645 19.8834 24.0067L20 24H22.5C22.7761 24 23 23.7761 23 23.5C23 23.2545 22.8231 23.0504 22.5898 23.0081L22.5 23H21.5C20.1193 23 19 21.8807 19 20.5C19 19.2903 19.8592 18.2813 21.0006 18.0499L21 17H23Z"
        fill="#0090FF"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 6H20V4H24C26.2091 4 28 5.79086 28 8V11H26V8C26 6.89543 25.1046 6 24 6Z"
        fill="#0090FF"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 26L11 26L11 28L8 28C5.79086 28 4 26.2091 4 24L4 23L6 23L6 24C6 25.1046 6.89543 26 8 26Z"
        fill="#0090FF"
      />
    </svg>
  );
};

export default Svg;
